import { IResultModel } from '@rift/models/restapi/Result.Model';
import { BaseModel } from '@shared/base/Base.Model';
import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { DateTimeNonMomentUtility } from '@shared/utility/DateTimeNonMoment.Utility';

export interface ISyncTimeModel extends IRestModel {
    time: Date;
}

export class SyncTimeModel extends BaseModel implements ISyncTimeModel, IResultModel, IRestModel {
    public readonly isIRestModel = true;

    public error: string = null;
    public statusCode: number = null;
    public time: Date = null;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'RIFT-SyncTimeModel');
    }

    public toRestApiModel(): any {
        return {
            ...RestModelUtility.toJson(this),
            Time: DateTimeNonMomentUtility.toRestApiDateTime(this.time),
        };
    }
}
